import { useState } from 'react';
import { CoveringsAPI } from '../../../../services/external/APIs/coverings/Coverings.api';
import { CoverSchedulingByEmployeeAndDate } from '../../models/coverScheduling';

interface Props {
    onChangeCoverPerson: (value: { id: number; fullName: string }) => void;
    coverScheduling: CoverSchedulingByEmployeeAndDate | undefined;
    setEmployees: (data: any) => void;
    onChangeCoverRequest: (
        name: string,
        value: string | null | number | undefined
    ) => void;
    employee?: { id: number; fullName: string };
}
export const CoverPersonSearchField = ({
    onChangeCoverPerson,
    coverScheduling,
    setEmployees,
    employee,
    onChangeCoverRequest,
}: Props) => {
    const [searchInput, setSearchInput] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const fetchCoverPerson = () => {
        setIsLoading(true);

        CoveringsAPI.getEmployeeCover(searchInput)
            .then((res) => {
                setSearchInput('');
                setErrorMessage('');
                setEmployees(res);
                onChangeCoverPerson(res);
            })
            .catch((err) => {
                setErrorMessage('Empleado no encontrado');
                setSearchInput('');
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <>
            <div className='col-12 col-md-6'>
                Cubridor 
                <span className='text-danger'>*</span>
                <div className='d-flex gap-2 align-items-center'>
                    {employee !== undefined ? (
                        <input
                            type='text'
                            className='form-control text-dark'
                            disabled={true}
                            readOnly
                            value={employee.fullName}
                        />
                    ) : (
                        <input
                            type='text'
                            name='cover-person'
                            className='form-control text-dark'
                            id='cover-person'
                            onChange={(e) => setSearchInput(e.target.value)}
                            placeholder={isLoading ? 'Cargando...' : 'Seleccione'}
                            disabled={isLoading}
                            value={searchInput}
                        />
                    )}
                    {employee !== undefined ? (
                        <i
                            className='btn btn-danger bx bxs-trash '
                            onClick={() => {
                                setEmployees(undefined);
                                onChangeCoverPerson({ id: 0, fullName: 'string' });
                                onChangeCoverRequest('compensationDate', null);
                            }}
                        ></i>
                    ) : (
                        <i
                            className='btn btn-primary ri-search-line'
                            onClick={fetchCoverPerson}
                        ></i>
                    )}
                </div>
                {errorMessage && <div style={{ fontSize: 10 }}>{errorMessage}</div>}
            </div>

            <div className='col-12 col-md-6'>
                * Turno asignado
                <input
                    type='text'
                    name=''
                    className='form-control text-dark'
                    id=''
                    value={
                        employee && coverScheduling
                            ? `${
                                  coverScheduling.interruptionTypeName ??
                                  coverScheduling.workshiftDescription
                              }`
                            : 'No tiene programación asignada'
                    }
                    disabled={true}
                />
            </div>
        </>
    );
};
